import { g as _extends$3, a as _inherits$1, b as _createClass$1, c as _classCallCheck$1, d as _callSuper, e as _defineProperty$1, i as _toConsumableArray } from './_rollupPluginBabelHelpers-047e4aae.js';
import React from 'react';
import PropTypes from 'prop-types';
import 'react-dom';
import { g as _inherits, h as _createSuper, j as _classCallCheck, k as _defineProperty, l as _assertThisInitialized, i as _createClass, _ as _slicedToArray } from './_rollupPluginBabelHelpers-b9ad31fa-7ae21c08.js';
import 'styled-components';
import { s as styleInject$1, u as useActivify, a as useEscapeKey, P as Portal$3 } from './withTooltip-92e0dfed.js';
import '@styled-system/space';
import '@styled-system/color';
import '@styled-system/border';
import '@styled-system/variant';
import '@styled-system/typography';
import { I as Icon } from './index-28a062d6-3659b895.js';
import './index-155df85b-a520c7f0.js';
import './generic-7099c3ed-1383f6f8.js';
import { B as Button } from './button-fb2021fd.js';
import './loader-4d85b9a1.js';
import './bole.js';
import { s as styleInject } from './style-inject.es-1f59c1d0.js';
import { a as PlatformSupportV2 } from './index-e7a24c72.js';

var css_248z = ".Sidebar_verticalMenu__2o5mD {\n  width: 56px;\n  min-width: 56px;\n  height: 100vh;\n  background-color: #27394c;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  -webkit-font-smoothing: antialiased; }\n  .Sidebar_verticalMenu__2o5mD.Sidebar_animating__3jKHV {\n    transition: 0.3s cubic-bezier(0.215, 0.61, 0.355, 1); }\n  .Sidebar_verticalMenuHeader__-eu7E {\n    display: flex;\n    align-items: center;\n    padding: 12px 0;\n    background-color: #37495c;\n    padding: 12px 12px; }\n    .Sidebar_verticalMenuHeaderLogo__1WS0u {\n      min-width: 32px;\n      width: 32px !important;\n      height: 32px !important;\n      margin-right: 12px; }\n    .Sidebar_verticalMenuHeaderText__1uB1T {\n      position: relative;\n      display: none;\n      font-size: 14px;\n      color: #fff;\n      white-space: nowrap;\n      opacity: 1;\n      transition: 0.2s ease-out;\n      font-family: \"Roboto\";\n      top: 1px;\n      flex: 1;\n      font-weight: 600; }\n  .Sidebar_verticalMenuItems__2evgx {\n    margin: 0;\n    padding: 0; }\n  .Sidebar_verticalMenuItem__3gLCR {\n    margin: 0;\n    line-height: 0;\n    position: relative;\n    display: flex;\n    align-items: center;\n    padding: 12px 18px;\n    cursor: pointer;\n    transition: 0.2s ease-out;\n    width: auto; }\n    .Sidebar_verticalMenuItem__3gLCR:hover {\n      background-color: #30465d; }\n    .Sidebar_verticalMenuItem__3gLCR.Sidebar_active__c-pnq {\n      background-color: #38526e; }\n      .Sidebar_verticalMenuItem__3gLCR.Sidebar_active__c-pnq .Sidebar_verticalMenuItemIcon__3XiV3 {\n        opacity: 1; }\n      .Sidebar_verticalMenuItem__3gLCR.Sidebar_active__c-pnq .Sidebar_verticalMenuItemText__O8ccx {\n        color: #fff;\n        flex: 1; }\n    .Sidebar_verticalMenuItemIcon__3XiV3 {\n      min-width: 20px;\n      width: 20px;\n      height: 20px;\n      margin-right: 8px; }\n      .Sidebar_verticalMenuItemIcon__3XiV3 svg:not(.platformSupport-svg) {\n        width: 100%;\n        height: 100%; }\n        .Sidebar_verticalMenuItemIcon__3XiV3 svg:not(.platformSupport-svg) * {\n          stroke: white;\n          fill: none; }\n    .Sidebar_verticalMenuItemText__O8ccx {\n      position: relative;\n      display: none;\n      font-size: 12px;\n      color: #eee;\n      white-space: nowrap;\n      opacity: 0;\n      transition: 0.2s ease-out;\n      font-family: \"Roboto\";\n      top: 1px;\n      flex: 1;\n      font-weight: 300; }\n  .Sidebar_verticalMenuFooter__2bAYv {\n    margin-top: auto;\n    margin-bottom: 0; }\n    .Sidebar_verticalMenuFooterExpand__2qjjd {\n      width: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background-color: #30465d;\n      padding: 8px;\n      height: auto;\n      box-sizing: border-box; }\n      .Sidebar_verticalMenuFooterExpand__2qjjd svg {\n        width: 16px;\n        height: 16px;\n        transition: 0.4s ease-out; }\n  .Sidebar_verticalMenu__2o5mD .Sidebar_platformSupport__1VeEo {\n    position: absolute;\n    z-index: 999999;\n    bottom: 14px;\n    margin-left: 70px;\n    transition: 0.3s cubic-bezier(0.215, 0.61, 0.355, 1); }\n  .Sidebar_verticalMenu__2o5mD.Sidebar_expanded__3IsAH .Sidebar_beamer_icon__1mw4o.Sidebar_active__c-pnq {\n    right: 1px !important; }\n  .Sidebar_verticalMenu__2o5mD.Sidebar_expanded__3IsAH .Sidebar_platformSupport__1VeEo {\n    margin-left: 214px; }\n  .Sidebar_verticalMenu__2o5mD.Sidebar_expanded__3IsAH .Sidebar_verticalMenuHeaderText__1uB1T,\n  .Sidebar_verticalMenu__2o5mD.Sidebar_expanded__3IsAH .Sidebar_verticalMenuItemText__O8ccx {\n    display: block;\n    opacity: 1; }\n  .Sidebar_verticalMenu__2o5mD.Sidebar_expanded__3IsAH .Sidebar_verticalMenuItem__3gLCR {\n    width: auto; }\n  .Sidebar_verticalMenu__2o5mD.Sidebar_expanded__3IsAH .Sidebar_verticalMenuFooter__2bAYv .Sidebar_toggle__ejTCC svg {\n    transform: rotate(180deg); }\n";
var styles = {"verticalMenu":"Sidebar_verticalMenu__2o5mD","animating":"Sidebar_animating__3jKHV","verticalMenuHeader":"Sidebar_verticalMenuHeader__-eu7E","verticalMenuHeaderLogo":"Sidebar_verticalMenuHeaderLogo__1WS0u","verticalMenuHeaderText":"Sidebar_verticalMenuHeaderText__1uB1T","verticalMenuItems":"Sidebar_verticalMenuItems__2evgx","verticalMenuItem":"Sidebar_verticalMenuItem__3gLCR","active":"Sidebar_active__c-pnq","verticalMenuItemIcon":"Sidebar_verticalMenuItemIcon__3XiV3","verticalMenuItemText":"Sidebar_verticalMenuItemText__O8ccx","verticalMenuFooter":"Sidebar_verticalMenuFooter__2bAYv","verticalMenuFooterExpand":"Sidebar_verticalMenuFooterExpand__2qjjd","platformSupport":"Sidebar_platformSupport__1VeEo","expanded":"Sidebar_expanded__3IsAH","beamer_icon":"Sidebar_beamer_icon__1mw4o","toggle":"Sidebar_toggle__ejTCC"};
styleInject(css_248z);

// Header Icon for sidebar
function HeaderIcon(_ref) {
  var tooltip = _ref.tooltip,
    tooltipPosition = _ref.tooltipPosition,
    name = _ref.name,
    onClick = _ref.onClick;
  var iconProps = {
    tooltip: tooltip,
    tooltipPosition: tooltipPosition,
    src: name,
    onClick: onClick
  };
  return /*#__PURE__*/React.createElement(Icon, _extends$3({}, iconProps, {
    className: "".concat(styles.verticalMenuHeaderLogo)
  }));
}
HeaderIcon.defaultProps = {
  tooltip: "Icon",
  tooltipPosition: "BOTTOM",
  onClick: function onClick() {}
};
HeaderIcon.propTypes = {
  tooltip: PropTypes.string,
  tooltipPosition: PropTypes.string,
  onClick: PropTypes.func,
  name: PropTypes.object.isRequired
};
function HeaderTitle(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement("span", {
    className: "".concat(styles.verticalMenuHeaderText)
  }, children);
}
HeaderTitle.propTypes = {
  // Children as title dom element
  // or combination of icon and title
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired
};

// Header wrapper
function SidebarHeader(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/React.createElement("section", {
    className: "".concat(styles.verticalMenuHeader)
  }, typeof children === "string" ? /*#__PURE__*/React.createElement(HeaderTitle, null, children) : children);
}
SidebarHeader.Icon = HeaderIcon;
SidebarHeader.Title = HeaderTitle;
SidebarHeader.propTypes = {
  // Children as title dom element
  // or combination of icon and title
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.string])
};
SidebarHeader.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SidebarHeader",
  "props": {
    "children": {
      "type": {
        "name": "union",
        "value": [{
          "name": "array"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": ""
    }
  }
};

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SidebarArrowIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "8",
  height: "12",
  viewBox: "0 0 8 12",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Side-Bar",
  transform: "translate(-28 -674)",
  stroke: "#FFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon/arrow/down",
  transform: "rotate(-90 356 336)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path-2",
  d: "M6 9l6 6 6-6"
}))))));

function SidebarFooter(_ref) {
  var onClick = _ref.onClick,
    className = _ref.className,
    children = _ref.children,
    noExpand = _ref.noExpand;
  return /*#__PURE__*/React.createElement("section", {
    className: "".concat(styles.verticalMenuFooter)
  }, children, !noExpand && /*#__PURE__*/React.createElement("div", {
    onClick: onClick,
    className: "".concat(styles.toggle)
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "".concat(styles.verticalMenuFooterExpand, " ").concat(className),
    src: SidebarArrowIcon
  })));
}
SidebarFooter.defaultProps = {
  className: "",
  noExpand: false
};
SidebarFooter.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  children: PropTypes.arrayOf(PropTypes.object),
  noExpand: PropTypes.bool
};
SidebarFooter.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SidebarFooter",
  "props": {
    "className": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "noExpand": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    },
    "children": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "object"
        }
      },
      "required": false,
      "description": ""
    }
  }
};

function SidebarMenu(_ref) {
  var children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("ul", {
    className: "".concat(styles.verticalMenuItems, " ").concat(className)
  }, children);
}
SidebarMenu.defaultProps = {
  className: ""
};
SidebarMenu.propTypes = {
  children: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object, PropTypes.bool])),
  className: PropTypes.string
};
SidebarMenu.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SidebarMenu",
  "props": {
    "className": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "union",
          "value": [{
            "name": "object"
          }, {
            "name": "bool"
          }]
        }
      },
      "required": false,
      "description": ""
    }
  }
};

function usePositioner(attachTo, contextMenuDOM, offset) {
  var _React$useState = React.useState({}),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    position = _React$useState2[0],
    setPosition = _React$useState2[1];
  React.useEffect(function () {
    if (!attachTo || !contextMenuDOM.current) return;
    var rect = attachTo.current ? attachTo.current.getBoundingClientRect() : attachTo.getBoundingClientRect();
    var contextMenuRect = contextMenuDOM.current.getBoundingClientRect();
    var position = {
      top: rect.top + offset.top,
      left: offset.xMode === 'LEFT' ? rect.left + offset.left : rect.right + offset.left
    };
    var diff = window.innerWidth - (rect.right + contextMenuRect.width);
    if (diff < 0) {
      position.left += diff;
    } else {
      diff = 0;
    }
    setPosition(position);
  }, [contextMenuDOM.current]);
  return position;
}

var css_248z$1 = ".ContextMenuPortal_contextMenuWrapper__1iLzp {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1099999999999; }\n\n.ContextMenuPortal_contextMenuOverlay__3JH68 {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%; }\n\n.ContextMenuPortal_contextMenu__2C5Kq {\n  opacity: 0;\n  position: absolute;\n  z-index: 2;\n  background-color: #fff;\n  border-radius: 8px;\n  outline: none;\n  filter: drop-shadow(rgba(0, 0, 0, 0.2) 3px 0px 12px);\n  transition: 0.1s ease-in-out;\n  transform: translate3d(0, -5px, 0);\n  overflow: hidden; }\n  .ContextMenuPortal_contextMenu__2C5Kq * {\n    font-family: 'Roboto', sans-serif; }\n  .ContextMenuPortal_contextMenu__2C5Kq.ContextMenuPortal_contextMenuActive__2H-Tk {\n    opacity: 1 !important;\n    transform: translate3d(0, 0px, 0) !important; }\n\n.ContextMenuPortal_contextMenuContent__3gEAb {\n  max-width: 550px;\n  overflow-y: auto; }\n";
var styles$1 = {"contextMenuWrapper":"ContextMenuPortal_contextMenuWrapper__1iLzp","contextMenuOverlay":"ContextMenuPortal_contextMenuOverlay__3JH68","contextMenu":"ContextMenuPortal_contextMenu__2C5Kq","contextMenuActive":"ContextMenuPortal_contextMenuActive__2H-Tk","contextMenuContent":"ContextMenuPortal_contextMenuContent__3gEAb"};
styleInject$1(css_248z$1);

var ContextMenuPortal = function ContextMenuPortal(_ref) {
  var active = _ref.active,
    className = _ref.className,
    onClose = _ref.onClose,
    children = _ref.children,
    maxHeight = _ref.maxHeight,
    attachTo = _ref.attachTo,
    offset = _ref.offset,
    prefixClassName = _ref.prefixClassName;
  var contextMenuDOM = React.useRef();
  var _useActivify = useActivify(active),
    enabled = _useActivify.enabled,
    visible = _useActivify.visible;
  var activeClassName = visible ? styles$1.contextMenuActive : "";
  var position = usePositioner(attachTo, contextMenuDOM, offset);
  useEscapeKey(onClose);
  if (!enabled) return null;
  return /*#__PURE__*/React.createElement(Portal$3, null, /*#__PURE__*/React.createElement("div", {
    "data-testid": "context-menu",
    className: "".concat(styles$1.contextMenuWrapper, " ").concat(className, " ").concat(prefixClassName)
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$1.contextMenuOverlay, " ").concat(prefixClassName, "-overlay"),
    onClick: onClose
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(activeClassName, " ").concat(styles$1.contextMenu, " ").concat(prefixClassName, "-context-menu"),
    ref: function ref(DOMNode) {
      if (DOMNode && active) DOMNode.focus();
      contextMenuDOM.current = DOMNode;
    },
    style: position
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$1.contextMenuContent, " ").concat(prefixClassName, "-context-menu-content"),
    style: {
      maxHeight: maxHeight || "300px"
    }
  }, children))));
};
ContextMenuPortal.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  prefixClassName: PropTypes.string,
  attachTo: PropTypes.object,
  maxHeight: PropTypes.number,
  onClose: PropTypes.func,
  offset: PropTypes.shape({
    left: PropTypes.number,
    top: PropTypes.number
  })
};
ContextMenuPortal.defaultProps = {
  offset: {
    left: 0,
    top: 0
  },
  onClose: function onClose() {}
};
ContextMenuPortal.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ContextMenuPortal",
  "props": {
    "offset": {
      "defaultValue": {
        "value": "{\n  left: 0,\n  top: 0,\n}",
        "computed": false
      },
      "type": {
        "name": "shape",
        "value": {
          "left": {
            "name": "number",
            "required": false
          },
          "top": {
            "name": "number",
            "required": false
          }
        }
      },
      "required": false,
      "description": ""
    },
    "onClose": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "active": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "prefixClassName": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "attachTo": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "maxHeight": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z$1$1 = ".ContextMenuItem_contextMenuItem__2syqN {\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid #eee;\n  padding: 10px;\n  min-width: 100px;\n  cursor: pointer;\n  transition: 0.2s ease-out;\n  text-decoration: none !important;\n  color: #222 !important; }\n  .ContextMenuItem_contextMenuItem__2syqN:last-child {\n    border-bottom: none; }\n  .ContextMenuItem_contextMenuItem__2syqN:hover {\n    background-color: #f5f5f5; }\n  .ContextMenuItem_contextMenuItem__2syqN.ContextMenuItem_disabled__3ZvLm {\n    pointer-events: none; }\n    .ContextMenuItem_contextMenuItem__2syqN.ContextMenuItem_disabled__3ZvLm .ContextMenuItem_contextMenuItemIcon__1sQmw {\n      opacity: 0.3; }\n    .ContextMenuItem_contextMenuItem__2syqN.ContextMenuItem_disabled__3ZvLm .ContextMenuItem_contextMenuItemText__3dEoQ {\n      opacity: 0.3; }\n\n.ContextMenuItem_contextMenuItemIcon__1sQmw {\n  width: 18px;\n  height: 18px;\n  border-radius: 8px;\n  margin-right: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n  .ContextMenuItem_contextMenuItemIcon__1sQmw svg {\n    width: 100%;\n    height: 100%; }\n\n.ContextMenuItem_contextMenuItemText__3dEoQ {\n  font-size: 12px; }\n  .ContextMenuItem_contextMenuItemText__3dEoQ.ContextMenuItem_big__3jkq3 {\n    font-size: 14px; }\n";
var styles$1$1 = {"contextMenuItem":"ContextMenuItem_contextMenuItem__2syqN","disabled":"ContextMenuItem_disabled__3ZvLm","contextMenuItemIcon":"ContextMenuItem_contextMenuItemIcon__1sQmw","contextMenuItemText":"ContextMenuItem_contextMenuItemText__3dEoQ","big":"ContextMenuItem_big__3jkq3"};
styleInject$1(css_248z$1$1);

var ContextMenuItem = function ContextMenuItem(_ref) {
  var title = _ref.title,
    icon = _ref.icon,
    iconType = _ref.iconType,
    iconSize = _ref.iconSize,
    onClick = _ref.onClick,
    disabled = _ref.disabled,
    children = _ref.children,
    size = _ref.size,
    href = _ref.href,
    className = _ref.className,
    prefixClassName = _ref.prefixClassName;
  var bigClassName = size === "big" ? styles$1$1.big : "";
  var Tag = href ? "a" : "div";
  return /*#__PURE__*/React.createElement(Tag, {
    "data-testid": "context-menu-item",
    href: href,
    target: "_blank",
    onClick: onClick,
    className: "".concat(styles$1$1.contextMenuItem, " ").concat(disabled ? styles$1$1.disabled : "", " ").concat(className, " ").concat(prefixClassName)
  }, /*#__PURE__*/React.createElement(Icon, {
    size: iconSize,
    className: "".concat(styles$1$1.contextMenuItemIcon, " ").concat(prefixClassName, "-icon"),
    src: iconType || icon
  }), /*#__PURE__*/React.createElement("span", {
    className: "".concat(styles$1$1.contextMenuItemText, " ").concat(bigClassName, " ").concat(prefixClassName, "-text")
  }, title || children));
};
ContextMenuItem.propTypes = {
  /** The name of the context menu item (display text) */
  title: PropTypes.string,
  /** The icon to display next to the display text */
  icon: PropTypes.node,
  /** If using a pre-existing icon */
  iconType: PropTypes.string,
  /** The size of the icon */
  iconSize: PropTypes.number,
  /** onClick callback */
  onClick: PropTypes.func,
  /** Whether the item is disabled or not */
  disabled: PropTypes.bool,
  /** Display text (same as the title prop) */
  children: PropTypes.node,
  /** The size of the item (big/small) */
  size: PropTypes.string,
  /** If the context menu item should be a link instead */
  href: PropTypes.string,
  /** Outermost className */
  className: PropTypes.string,
  /** className appended to each of the elements */
  prefixClassName: PropTypes.string
};
ContextMenuItem.defaultProps = {
  title: "",
  iconType: "",
  className: "",
  prefixClassName: "",
  icon: null,
  iconSize: 24,
  onClick: function onClick() {},
  disabled: false,
  children: null,
  size: "small",
  href: null
};
ContextMenuItem.classNames = {
  $prefix: "Outermost element",
  "$prefix-icon": "The icon",
  "$prefix-text": "The text"
};
ContextMenuItem.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ContextMenuItem",
  "props": {
    "title": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The name of the context menu item (display text)"
    },
    "iconType": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "If using a pre-existing icon"
    },
    "className": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Outermost className"
    },
    "prefixClassName": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "className appended to each of the elements"
    },
    "icon": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "The icon to display next to the display text"
    },
    "iconSize": {
      "defaultValue": {
        "value": "24",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "The size of the icon"
    },
    "onClick": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "onClick callback"
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Whether the item is disabled or not"
    },
    "children": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "Display text (same as the title prop)"
    },
    "size": {
      "defaultValue": {
        "value": "\"small\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The size of the item (big/small)"
    },
    "href": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "If the context menu item should be a link instead"
    }
  }
};

var css_248z$2 = ".ContextMenuButton_contextMenuButtonIcon__3wa4Q {\n  position: relative;\n  width: 14px;\n  height: 14px;\n  margin-left: 8px;\n  display: flex;\n  align-items: center;\n  top: 2px; }\n";
var styles$2 = {"contextMenuButtonIcon":"ContextMenuButton_contextMenuButtonIcon__3wa4Q"};
styleInject$1(css_248z$2);

var ContextMenuButton = /*#__PURE__*/function (_React$Component) {
  _inherits(ContextMenuButton, _React$Component);
  var _super = _createSuper(ContextMenuButton);
  function ContextMenuButton() {
    var _this;
    _classCallCheck(this, ContextMenuButton);
    _this = _super.call(this);
    _defineProperty(_assertThisInitialized(_this), "_handleClick", function (e) {
      e.preventDefault();
      e.stopPropagation();
      _this.setState({
        active: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleClose", function (e) {
      e.preventDefault();
      e.stopPropagation();
      _this.setState({
        active: false
      });
    });
    _this.state = {
      active: false
    };
    return _this;
  }
  _createClass(ContextMenuButton, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        className = _this$props.className,
        offset = _this$props.offset,
        children = _this$props.children,
        title = _this$props.title,
        size = _this$props.size,
        type = _this$props.type,
        prefixClassName = _this$props.prefixClassName;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ContextMenuPortal, {
        active: this.state.active,
        attachTo: this._contextMenuIcon,
        offset: offset,
        onClose: this.handleClose,
        prefixClassName: "".concat(prefixClassName, "-portal")
      }, typeof children === "function" ? children(this.handleClose) : children), /*#__PURE__*/React.createElement(Button, {
        type: type,
        size: size,
        style: {
          cursor: "pointer"
        },
        onClick: this._handleClick,
        className: "".concat(prefixClassName, " ").concat(className),
        innerRef: function innerRef(DOMElement) {
          _this2._contextMenuIcon = DOMElement;
        }
      }, title, /*#__PURE__*/React.createElement(Icon, {
        prefixClassName: "".concat(prefixClassName, "-icon"),
        className: styles$2.contextMenuButtonIcon,
        src: "angle-down"
      })));
    }
  }]);
  return ContextMenuButton;
}(React.Component);
ContextMenuButton.propTypes = {
  /** Outermost className */
  className: PropTypes.string,
  /** className appended to each of the elements */
  prefixClassName: PropTypes.string,
  /** What needs to be rendered inside the context menu */
  children: PropTypes.node,
  /** Offset prop to adjust the element's position */
  offset: PropTypes.shape({
    left: PropTypes.number,
    top: PropTypes.number
  }),
  /** The size of the button */
  size: PropTypes.number,
  /** The title of the button */
  title: PropTypes.string,
  /** The type of button */
  type: PropTypes.string
};
ContextMenuButton.defaultProps = {
  className: "",
  prefixClassName: "",
  offset: null,
  size: 0,
  title: ""
};
ContextMenuButton.classNames = {
  $prefix: "Outermost className (button)",
  "$prefix-icon": "the down arrow on the button",
  "$prefix-portal": "className for the portal",
  "$prefix-portal-overlay": "overlay",
  "$prefix-portal-context-menu": "wrapping content div",
  "$prefix-portal-context-menu-content": "the actual content div"
};
ContextMenuButton.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "_handleClick",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "handleClose",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "ContextMenuButton",
  "props": {
    "className": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Outermost className"
    },
    "prefixClassName": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "className appended to each of the elements"
    },
    "offset": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "shape",
        "value": {
          "left": {
            "name": "number",
            "required": false
          },
          "top": {
            "name": "number",
            "required": false
          }
        }
      },
      "required": false,
      "description": "Offset prop to adjust the element's position"
    },
    "size": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "The size of the button"
    },
    "title": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The title of the button"
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "What needs to be rendered inside the context menu"
    },
    "type": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The type of button"
    }
  }
};

var ContextMenuIcon = /*#__PURE__*/function (_React$Component) {
  _inherits(ContextMenuIcon, _React$Component);
  var _super = _createSuper(ContextMenuIcon);
  function ContextMenuIcon() {
    var _this;
    _classCallCheck(this, ContextMenuIcon);
    _this = _super.call(this);
    _defineProperty(_assertThisInitialized(_this), "_handleClick", function (e) {
      e.preventDefault();
      e.stopPropagation();
      _this.setState({
        active: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_handleOverlayClick", function (e) {
      e.preventDefault();
      e.stopPropagation();
      _this.setState({
        active: false
      });
    });
    _this.state = {
      active: false
    };
    return _this;
  }
  _createClass(ContextMenuIcon, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        className = _this$props.className,
        offset = _this$props.offset,
        children = _this$props.children,
        iconType = _this$props.iconType,
        iconComponent = _this$props.iconComponent,
        maxHeight = _this$props.maxHeight,
        prefixClassName = _this$props.prefixClassName;
      return /*#__PURE__*/React.createElement(React.Fragment, null, iconComponent ? /*#__PURE__*/React.cloneElement(iconComponent, {
        onClick: this._handleClick,
        ref: function ref(DOMElement) {
          _this2._contextMenuIcon = DOMElement;
        }
      }) : /*#__PURE__*/React.createElement(Icon, {
        prefixClassName: "".concat(prefixClassName),
        style: {
          cursor: "pointer"
        },
        onClick: this._handleClick,
        src: iconType,
        className: className,
        innerRef: function innerRef(DOMElement) {
          _this2._contextMenuIcon = DOMElement;
        }
      }), /*#__PURE__*/React.createElement(ContextMenuPortal, {
        active: this.state.active,
        attachTo: this._contextMenuIcon,
        offset: offset,
        onClose: this._handleOverlayClick,
        maxHeight: maxHeight,
        prefixClassName: "".concat(prefixClassName, "-portal")
      }, typeof children === "function" ? children(this._handleOverlayClick) : children));
    }
  }]);
  return ContextMenuIcon;
}(React.Component);
ContextMenuIcon.propTypes = {
  /** Outermost className */
  className: PropTypes.string,
  /** className appended to each of the elements */
  prefixClassName: PropTypes.string,
  /** What needs to be rendered inside the context menu */
  children: PropTypes.node,
  /** Offset prop to adjust the element's position */
  offset: PropTypes.shape({
    left: PropTypes.number,
    top: PropTypes.number
  }),
  /** The size of the button */
  maxHeight: PropTypes.number,
  /** The icon type (string) */
  iconType: PropTypes.string,
  /** The icon component in case some other component needs to be rendered */
  iconComponent: PropTypes.string
};
ContextMenuIcon.defaultProps = {
  offset: {
    left: 0,
    top: 0
  },
  children: null,
  className: "",
  prefixClassName: "",
  maxHeight: 200,
  iconType: "circle-more",
  iconComponent: null
};
ContextMenuIcon.classNames = {
  $prefix: "Outermost className (icon)",
  "$prefix-portal": "className for the portal",
  "$prefix-portal-overlay": "overlay",
  "$prefix-portal-context-menu": "wrapping content div",
  "$prefix-portal-context-menu-content": "the actual content div"
};
ContextMenuIcon.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "_handleClick",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_handleOverlayClick",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "ContextMenuIcon",
  "props": {
    "offset": {
      "defaultValue": {
        "value": "{\n  left: 0,\n  top: 0,\n}",
        "computed": false
      },
      "type": {
        "name": "shape",
        "value": {
          "left": {
            "name": "number",
            "required": false
          },
          "top": {
            "name": "number",
            "required": false
          }
        }
      },
      "required": false,
      "description": "Offset prop to adjust the element's position"
    },
    "children": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "What needs to be rendered inside the context menu"
    },
    "className": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Outermost className"
    },
    "prefixClassName": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "className appended to each of the elements"
    },
    "maxHeight": {
      "defaultValue": {
        "value": "200",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "The size of the button"
    },
    "iconType": {
      "defaultValue": {
        "value": "\"circle-more\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The icon type (string)"
    },
    "iconComponent": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The icon component in case some other component needs to be rendered"
    }
  }
};

var ContextMenu = function ContextMenu(props) {
  // it warrants it here since this is just a wrapper
  // eslint-disable-next-line react/jsx-props-no-spreading
  return /*#__PURE__*/React.createElement(ContextMenuPortal, props);
};
ContextMenu.Item = ContextMenuItem;
ContextMenu.Button = ContextMenuButton;
ContextMenu.Icon = ContextMenuIcon;
ContextMenu.propTypes = {
  /** Whether the context menu is active or not */
  active: PropTypes.bool,
  /** What needs to be rendered inside the context menu */
  children: PropTypes.node,
  /** Outermost className */
  className: PropTypes.string,
  /** className appended to each of the elements */
  prefixClassName: PropTypes.string,
  /** The DOM Element to attach the context menu to */
  attachTo: PropTypes.object,
  /** The onClose callback */
  onClose: PropTypes.func,
  /** Offset prop to adjust the element's position */
  offset: PropTypes.shape({
    left: PropTypes.number,
    top: PropTypes.number
  })
};
ContextMenu.defaultProps = {
  active: false,
  className: "",
  prefixClassName: "",
  attachTo: {},
  onClose: function onClose() {},
  offset: null
};
ContextMenu.classNames = {
  $prefix: "portal element",
  "$prefix-overlay": "overlay",
  "$prefix-context-menu": "wrapping content div",
  "$prefix-context-menu-content": "the actual content div"
};
ContextMenu.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ContextMenu",
  "props": {
    "active": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Whether the context menu is active or not"
    },
    "className": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Outermost className"
    },
    "prefixClassName": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "className appended to each of the elements"
    },
    "attachTo": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "The DOM Element to attach the context menu to"
    },
    "onClose": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "The onClose callback"
    },
    "offset": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "shape",
        "value": {
          "left": {
            "name": "number",
            "required": false
          },
          "top": {
            "name": "number",
            "required": false
          }
        }
      },
      "required": false,
      "description": "Offset prop to adjust the element's position"
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "What needs to be rendered inside the context menu"
    }
  }
};

function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var AccountIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "icon/account",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.193 11.88a3.44 3.44 0 110-6.88 3.44 3.44 0 010 6.88zM6 19c1.157-3.37 3.222-5.055 6.193-5.055 2.97 0 5.035 1.685 6.192 5.055H6z",
  id: "Combined-Shape",
  stroke: "#333"
}))));

function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var HelpIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$2({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30 20.302a9.727 9.727 0 00-5.334-8.661c-.1 7.138-5.887 12.925-13.024 13.024A9.727 9.727 0 0020.302 30a9.662 9.662 0 004.935-1.349l4.72 1.306-1.305-4.72A9.662 9.662 0 0030 20.302z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.91 11.455C22.91 5.14 17.771 0 11.455 0S0 5.139 0 11.455c0 2.059.548 4.063 1.588 5.823l-1.546 5.59 5.59-1.546a11.42 11.42 0 005.823 1.588c6.316 0 11.455-5.139 11.455-11.455z",
  fill: "#006DEA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.52 12.623c0-.712.08-1.274.241-1.684.161-.415.423-.774.784-1.077.361-.302.635-.578.82-.827a1.36 1.36 0 00.286-.835c0-.738-.317-1.106-.952-1.106a.883.883 0 00-.71.322c-.181.215-.277.505-.286.872H8.227c.01-.977.317-1.736.923-2.278.605-.547 1.455-.82 2.549-.82 1.089 0 1.93.25 2.527.754.6.503.9 1.218.9 2.146a2.5 2.5 0 01-.241 1.106c-.161.332-.42.671-.777 1.018l-.842.784c-.24.23-.405.466-.498.71-.093.24-.144.544-.154.915H10.52zm-.3 2.227c0-.361.129-.657.387-.886.264-.235.591-.352.982-.352.39 0 .715.117.974.352.264.23.396.525.396.886s-.132.66-.396.894c-.259.23-.584.344-.974.344s-.718-.115-.982-.344a1.153 1.153 0 01-.388-.894z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h30v30H0z"
})))));

var SidebarMenuItem = /*#__PURE__*/function (_React$PureComponent) {
  function SidebarMenuItem() {
    _classCallCheck$1(this, SidebarMenuItem);
    return _callSuper(this, SidebarMenuItem, arguments);
  }
  _inherits$1(SidebarMenuItem, _React$PureComponent);
  return _createClass$1(SidebarMenuItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        divId = _this$props.divId,
        onClick = _this$props.onClick,
        children = _this$props.children,
        tooltip = _this$props.tooltip,
        tooltipPosition = _this$props.tooltipPosition,
        icon = _this$props.icon,
        isActive = _this$props.isActive,
        innerRef = _this$props.innerRef,
        iconRef = _this$props.iconRef,
        className = _this$props.className,
        prefixClassName = _this$props.prefixClassName;
      return /*#__PURE__*/React.createElement("li", {
        className: "".concat(styles.verticalMenuItem, " ").concat(className, " ").concat(isActive ? styles.active : ""),
        ref: innerRef,
        onClick: onClick,
        id: divId
      }, /*#__PURE__*/React.createElement("span", {
        ref: iconRef
      }, /*#__PURE__*/React.createElement(Icon, {
        tooltip: tooltip,
        tooltipPosition: tooltipPosition,
        src: icon,
        className: "".concat(styles.verticalMenuItemIcon),
        prefixClassName: prefixClassName
      })), /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.verticalMenuItemText, " ").concat(prefixClassName, "-text")
      }, children));
    }
  }]);
}(React.PureComponent);
SidebarMenuItem.defaultProps = {
  tooltipPosition: "TOP",
  className: "",
  prefixClassName: "",
  divId: ""
};
SidebarMenuItem.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired,
  tooltipPosition: PropTypes.string,
  divId: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  isActive: PropTypes.bool.isRequired,
  innerRef: PropTypes.func,
  iconRef: PropTypes.func,
  className: PropTypes.string,
  prefixClassName: PropTypes.string
};
SidebarMenuItem.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SidebarMenuItem",
  "props": {
    "tooltipPosition": {
      "defaultValue": {
        "value": "\"TOP\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "prefixClassName": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "divId": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    },
    "children": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "tooltip": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "icon": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "func"
        }]
      },
      "required": false,
      "description": ""
    },
    "isActive": {
      "type": {
        "name": "bool"
      },
      "required": true,
      "description": ""
    },
    "innerRef": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "iconRef": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};

var PAGES = {
  mogambo_all_view: {
    title: "Conversation Studio",
    url: "/mogambo"
  },
  content_store_view: {
    title: "Content Store",
    url: "/admin_tools/custom_messages/"
  },
  admin_publisher_tools_view: {
    title: "Admin Tools",
    url: "/haptik_admin"
  },
  iva_analytics_all_view: {
    title: "Intelligent Analytics",
    url: "/dashboard"
  },
  athena_tool_access: {
    title: "Smart Agent Chat",
    url: "/athena"
  }
};
var TOGGLE_HEIGHT = 32;
var MENU_ITEM_HEIGHT = 44;
var ACTIVE = {
  PROFILE_MENU: "PROFILE_MENU",
  APP_MENU: "APP_MENU",
  FEEDBACK_MODAL: "FEEDBACK_MODAL",
  SUPPORT_BOT: "SUPPORT_BOT"
};

var css_248z$3 = ".styles_profileSection__tglmr .styles_capitalize__1c3-B {\n  text-transform: capitalize; }\n\n.styles_feedbackModalBody__qCnGd {\n  padding: 0 16px; }\n\n.styles_cancelBtn__3ge3b {\n  margin-right: 10px;\n  width: 10em; }\n\n.styles_textArea__35px4 textarea {\n  max-height: 200px;\n  overflow-y: scroll; }\n\n.styles_platformSupport__3CDq9 {\n  margin-top: 18px;\n  margin-bottom: 14px !important; }\n\n.platformSupport {\n  min-width: 30px;\n  height: 30px !important;\n  margin-left: -6px;\n  margin-right: 12px; }\n  .platformSupport-text {\n    font-weight: 500;\n    font-size: 14px; }\n";
var styles$3 = {"profileSection":"styles_profileSection__tglmr","capitalize":"styles_capitalize__1c3-B","feedbackModalBody":"styles_feedbackModalBody__qCnGd","cancelBtn":"styles_cancelBtn__3ge3b","textArea":"styles_textArea__35px4","platformSupport":"styles_platformSupport__3CDq9"};
styleInject(css_248z$3);

var SidebarProfile = /*#__PURE__*/function (_React$Component) {
  function SidebarProfile(props) {
    var _this;
    _classCallCheck$1(this, SidebarProfile);
    _this = _callSuper(this, SidebarProfile, [props]);
    _defineProperty$1(_this, "_getApps", function (permissions) {
      return permissions.filter(function (permission, pos) {
        return permissions.indexOf(permission) === pos;
      }).sort(function (a, b) {
        if (!PAGES[a] && !PAGES[b]) return 1;
        if (!PAGES[a] || !PAGES[b]) return -1;
        return PAGES[a].title > PAGES[b].title;
      }).reduce(function (acc, permission) {
        var page = PAGES[permission];
        if (page) acc = [].concat(_toConsumableArray(acc), [page]);
        return acc;
      }, []);
    });
    _defineProperty$1(_this, "_toggleUI", function (activeUI) {
      return !_this.state.activeUI ? _this._activateUI(activeUI) : _this._deactivateUI();
    });
    _defineProperty$1(_this, "_activateUI", function (activeUI) {
      return _this.setState({
        activeUI: activeUI
      });
    });
    _defineProperty$1(_this, "_deactivateUI", function () {
      return _this.setState({
        activeUI: null
      });
    });
    _defineProperty$1(_this, "_setAppRef", function (elem) {
      _this.appsMenuItem = elem;
    });
    _defineProperty$1(_this, "_setProfileRef", function (elem) {
      _this.profileMenuItem = elem;
    });
    _defineProperty$1(_this, "_handleLogout", function () {
      _this.props.logout();
    });
    _this.state = {
      apps: _this._getApps(props.permissions)
    };
    return _this;
  }
  _inherits$1(SidebarProfile, _React$Component);
  return _createClass$1(SidebarProfile, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        apps = _this$state.apps,
        activeUI = _this$state.activeUI;
      var _this$props = this.props,
        username = _this$props.username,
        permissions = _this$props.permissions,
        useremail = _this$props.useremail,
        toolname = _this$props.toolname,
        authcode = _this$props.authcode;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SidebarMenu, {
        className: styles$3.profileSection
      }, apps.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SidebarMenuItem, {
        icon: "grid",
        iconRef: this._setAppRef,
        isActive: activeUI === ACTIVE.APP_MENU,
        onClick: function onClick() {
          return _this2._toggleUI(ACTIVE.APP_MENU);
        },
        tooltip: "Select Haptik apps"
      }, "Haptik Apps"), /*#__PURE__*/React.createElement(ContextMenu, {
        attachTo: this.appsMenuItem,
        active: activeUI === ACTIVE.APP_MENU,
        onClose: this._deactivateUI,
        offset: {
          left: 0,
          top: -(MENU_ITEM_HEIGHT * (apps.length - 1) + TOGGLE_HEIGHT)
        }
      }, apps.map(function (page) {
        return /*#__PURE__*/React.createElement(ContextMenu.Item, {
          size: "big",
          href: page.url,
          onClick: function onClick() {
            return _this2._toggleUI(ACTIVE.APP_MENU);
          }
        }, page.title);
      }))), /*#__PURE__*/React.createElement(SidebarMenuItem, {
        icon: AccountIcon,
        iconRef: this._setProfileRef,
        isActive: activeUI === ACTIVE.PROFILE_MENU,
        onClick: function onClick() {
          return _this2._toggleUI(ACTIVE.PROFILE_MENU);
        },
        tooltip: "Profile actions",
        className: styles$3.capitalize
      }, username), /*#__PURE__*/React.createElement(ContextMenu, {
        active: activeUI === ACTIVE.PROFILE_MENU,
        attachTo: this.profileMenuItem,
        onClose: this._deactivateUI,
        offset: {
          left: 0,
          top: -(TOGGLE_HEIGHT + MENU_ITEM_HEIGHT)
        }
      }, /*#__PURE__*/React.createElement(ContextMenu.Item, {
        size: "big",
        href: "/profile/",
        onClick: function onClick() {
          return _this2._toggleUI(ACTIVE.PROFILE_MENU);
        }
      }, "My Profile"), /*#__PURE__*/React.createElement(ContextMenu.Item, {
        size: "big",
        onClick: this._handleLogout
      }, "Logout")), permissions.includes("platform_support_bot_user") && /*#__PURE__*/React.createElement(PlatformSupportV2, {
        customButton: /*#__PURE__*/React.createElement(SidebarMenuItem, {
          icon: HelpIcon,
          className: styles$3.platformSupport,
          prefixClassName: "platformSupport",
          tooltip: "Help"
        }, "Help"),
        username: username,
        useremail: useremail,
        toolname: toolname,
        authcode: authcode
      })));
    }
  }]);
}(React.Component);
SidebarProfile.defaultProps = {
  permissions: [],
  username: "My profile",
  authcode: "My profile"
};
SidebarProfile.propTypes = {
  logout: PropTypes.func.isRequired,
  permissions: PropTypes.array,
  username: PropTypes.string,
  authcode: PropTypes.string,
  useremail: PropTypes.string,
  toolname: PropTypes.string
};
SidebarProfile.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "_getApps",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "permissions",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_toggleUI",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "activeUI",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_activateUI",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "activeUI",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_deactivateUI",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_setAppRef",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "elem",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_setProfileRef",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "elem",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_handleLogout",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "SidebarProfile",
  "props": {
    "permissions": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "array"
      },
      "required": false,
      "description": ""
    },
    "username": {
      "defaultValue": {
        "value": "\"My profile\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "authcode": {
      "defaultValue": {
        "value": "\"My profile\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "logout": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    },
    "useremail": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "toolname": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};

var Sidebar = /*#__PURE__*/function (_React$Component) {
  function Sidebar(props) {
    var _this;
    _classCallCheck$1(this, Sidebar);
    _this = _callSuper(this, Sidebar, [props]);
    _defineProperty$1(_this, "getChildrenWithFooter", function (children) {
      var isSidebarFooter = function isSidebarFooter(child) {
        return child.type.name === SidebarFooter.name || child.type.displayName === SidebarFooter.name;
      };
      var hasFooter = !!children.filter(function (child) {
        return isSidebarFooter(child);
      }).length;
      var footerProp = {
        onClick: _this.toggle
      };
      if (hasFooter) {
        return children.map(function (child) {
          return isSidebarFooter(child) ? /*#__PURE__*/React.cloneElement(child, footerProp) : child;
        });
      }
      return [].concat(_toConsumableArray(children), [SidebarFooter(footerProp)]);
    });
    _defineProperty$1(_this, "toggle", function () {
      var isExpanded = _this.state.isExpanded;
      _this.setState({
        width: isExpanded ? _this.WIDTH.COLLAPSED : _this.WIDTH.EXPANDED,
        isExpanded: !isExpanded
      });
      setTimeout(function () {
        return document.dispatchEvent(new Event("menuResize"));
      }, 200);
    });
    var minWidth = props.minWidth,
      maxWidth = props.maxWidth,
      _isExpanded = props.isExpanded;
    _this.WIDTH = {
      COLLAPSED: minWidth,
      EXPANDED: maxWidth
    };
    _this.state = {
      width: _isExpanded ? _this.WIDTH.EXPANDED : _this.WIDTH.COLLAPSED,
      isExpanded: _isExpanded
    };
    return _this;
  }
  _inherits$1(Sidebar, _React$Component);
  return _createClass$1(Sidebar, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var children = this.props.children;
      var isExpanded = this.state.isExpanded;
      return nextProps.children !== children || nextState.isExpanded !== isExpanded;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children;
      var _this$state = this.state,
        width = _this$state.width,
        isExpanded = _this$state.isExpanded;
      var modifiedChildren = this.getChildrenWithFooter(children);
      var classNameExpanded = isExpanded ? styles.expanded : "";
      return /*#__PURE__*/React.createElement("aside", {
        className: "".concat(styles.verticalMenu, " ").concat(styles.animating, " ").concat(classNameExpanded, " ").concat(className),
        style: {
          width: width
        }
      }, modifiedChildren);
    }
  }]);
}(React.Component);
Sidebar.defaultProps = {
  className: "",
  maxWidth: 200,
  minWidth: 56,
  isExpanded: false
};
Sidebar.propTypes = {
  children: PropTypes.arrayOf(PropTypes.object).isRequired,
  className: PropTypes.string,
  maxWidth: PropTypes.number,
  minWidth: PropTypes.number,
  isExpanded: PropTypes.bool
};
Sidebar.Header = SidebarHeader;
Sidebar.Menu = SidebarMenu;
Sidebar.MenuItem = SidebarMenuItem;
Sidebar.Footer = SidebarFooter;
Sidebar.Profile = SidebarProfile;
Sidebar.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "getChildrenWithFooter",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "children",
      "type": null
    }],
    "returns": null
  }, {
    "name": "toggle",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "Sidebar",
  "props": {
    "className": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "maxWidth": {
      "defaultValue": {
        "value": "200",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "minWidth": {
      "defaultValue": {
        "value": "56",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "isExpanded": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "object"
        }
      },
      "required": true,
      "description": ""
    }
  }
};

export default Sidebar;
